<template>
  <div class="unsupported">
    <BaseText3 class="title" :text="title"/>
    <BaseText6 class="subtitle" :text="subtitle" v-if="subtitle"/>
  </div>
</template>

<script>
import BaseText3 from '@/components/BaseText3/BaseText3'
import BaseText6 from '@/components/BaseText6/BaseText6'
export default {
  name: 'unsupported',
  components: {
    BaseText3,
    BaseText6
  },
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: false
    }
  }
}
</script>

<style lang="scss" scoped>
.unsupported {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.title {
  font-size: 3.5rem;
  line-height: 3rem;
}
.subtitle {
  margin-top: 5rem;
}
</style>
